<template>
  <v-container
    class="performance-base-container ma-0 pa-0"
    fluid
  >
    <div v-if="showAlert">
        <v-alert
          class="v-alert alert_overlay"
          v-model="showAlert"
          border="left"
          close-text="Close Alert"
          dismissible
          :type="alertType"
        >
          {{ alertMsg }}
        </v-alert>
    </div>
    <v-row v-if="export_overlay">
      <v-col cols="12">
        <v-overlay :absolute="true" :value="export_overlay" :z-index="999">
          <v-card class="pa-3 overlay_card">
            <v-row justify="center" align="center" style="height: 100%; width: 100%">
              <v-col cols="auto">
                <v-progress-circular indeterminate size="300" color="black">
                  <v-row
                    style="height: 100%; width: 100%"
                    align="center"
                    justify="center"
                >
                    <v-col cols="auto" align="center">
                      <span>{{ export_loading_message }}</span>
                    </v-col>
                  </v-row>
                </v-progress-circular>
              </v-col>
            </v-row>
          </v-card>
        </v-overlay>
      </v-col>
    </v-row>
    <v-row class="ma-0 pa-0" style="height: 100%">
      <v-col
        cols="12"
        class="ma-0 pa-0"
        v-if="sliderElements.length > 0 && $stock_ticker" 
      >
        <vue-marquee-slider
          id="marquee-slider"
          :speed="35000 * sliderElements.length"
          :width="1600"
          class="marquee_slider"
        >
          <div class="sliderElement" v-for="(elm, idx) in sliderElements" :key="idx">
            <div class="sliderElement">
              <v-row class="slider-summary-row ma-0 pa-0" align="center" justify="center">
                <v-col cols="auto" align="center" class="ma-0 pa-0 pr-3">
                  <v-icon color="white">mdi-rhombus</v-icon>
                </v-col>
                <v-col cols="auto" align="center" class="ma-0 pa-0">
                  <span>{{ elm.name }} </span>
                </v-col>
                <v-col cols="8" class="ma-0 pa-0">
                  <v-row class="ma-0 pa-0">
                    <v-col cols="4" align="center" class="ma-0 pa-0">
                      <span>Spend @ </span>
                      <span
                        :class="
                          elm.Spend['value'] >= 0
                            ? 'sliderElementValueGreen'
                            : 'sliderElementValueRed'
                        "
                      >
                        {{
                          elm.Spend["value"].toLocaleString("en-CA", {
                            style: "currency",
                            currency: "CAD",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        }}
                        <v-icon
                          v-if="elm.Spend['value'] >= 0"
                          class="sliderElementValueGreen sliderElementIcon"
                          large
                          >mdi-menu-up</v-icon
                        >
                        <v-icon
                          v-else
                          class="sliderElementValueRed sliderElementIcon"
                          large
                          >mdi-menu-down</v-icon
                        >
                        {{
                          elm.Spend["percentage"].toLocaleString("en-CA", {
                            style: "percent",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        }}
                      </span>
                    </v-col>
                    <v-col cols="4" align="center" class="ma-0 pa-0">
                      <span>ROI @ </span>
                      <span
                        :class="
                          elm.ROI['value'] >= 0
                            ? 'sliderElementValueGreen'
                            : 'sliderElementValueRed'
                        "
                      >
                        {{
                          elm.ROI["value"].toLocaleString("en-CA", {
                            style: "currency",
                            currency: "CAD",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        }}
                        <v-icon
                          v-if="elm.ROI['value'] >= 0"
                          class="sliderElementValueGreen sliderElementIcon"
                          large
                          >mdi-menu-up</v-icon
                        >
                        <v-icon
                          v-else
                          class="sliderElementValueRed sliderElementIcon"
                          large
                          >mdi-menu-down</v-icon
                        >
                        {{
                          elm.ROI["percentage"].toLocaleString("en-CA", {
                            style: "percent",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        }}
                      </span>
                    </v-col>
                    <v-col cols="4" align="center" class="ma-0 pa-0">
                      <span>Volume @ </span>
                      <span
                        :class="
                          elm['Sales Attribution']['value'] >= 0
                            ? 'sliderElementValueGreen'
                            : 'sliderElementValueRed'
                        "
                      >
                        {{
                          elm["Sales Attribution"]["value"].toLocaleString("en-CA", {
                            style: "currency",
                            currency: "CAD",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        }}
                        <v-icon
                          v-if="elm['Sales Attribution']['value'] >= 0"
                          class="sliderElementValueGreen sliderElementIcon"
                          large
                          >mdi-menu-up</v-icon
                        >
                        <v-icon
                          v-else
                          class="sliderElementValueRed sliderElementIcon"
                          large
                          >mdi-menu-down</v-icon
                        >
                        {{
                          elm["Sales Attribution"]["percentage"].toLocaleString("en-CA", {
                              style: "percent",
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                          })
                        }}
                      </span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="auto" align="center" class="ma-0 pa-0 pl-3">
                  <v-icon color="white">mdi-rhombus</v-icon>
                </v-col>
              </v-row>
            </div>
          </div>
        </vue-marquee-slider>
      </v-col>
      <v-col cols="12" class="ma-0 pa-0" v-else-if="$stock_ticker">
        <div class="marquee_slider" style="height: 40px"></div>
      </v-col> 
      <v-col cols="12" class="ma-0 pa-0" style="height: 100%">
        <!-- Title And Highlights Row-->
        <v-row style="min-height: 10%; max-height: 20" class="ma-0 px-6 pt-4 pb-2">
          <!-- Title Column-->
          <v-col cols="12" class="ma-0 pa-0">
            <v-row width="100%" class="ma-0 pa-0">
              <v-col cols="auto" class="ma-0 pa-0">
                <v-img
                  :src="main_logo"
                  max-height="48px"
                  max-width="80px"
                  contain
                ></v-img>
              </v-col>
              <v-col cols="auto" class="ma-0 pa-0">
                <span class="page-title">Performance</span>
              </v-col>
              <v-spacer></v-spacer>
              <v-col sm="6" md="5" lg="4" class="ma-0 pa-0">
                <v-row class="ma-0 pa-0" style="height: 100%; width: 100%">
                  <v-col cols="4" class="ma-0 pa-0">
                    <PerformanceMainStatistic
                      statistic_title_name="Attribution"
                      :value="total_attribution"
                    />
                  </v-col>
                  <v-col cols="4" class="ma-0 pa-0">
                    <PerformanceMainStatistic
                      statistic_title_name="ROAS"
                      :value="total_roas"
                    />
                  </v-col>
                  <v-col cols="4" class="ma-0 pa-0">
                    <PerformanceMainStatistic
                      statistic_title_name="Spend"
                      :value="total_spend"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row width="80%" class="ma-0 pa-0" style="display: flex">
              <v-tabs v-model="performance_tab" align-tabs="start" light style="flex:2">
                <v-tab class="tool-navigation-bar" href="#performance">My Portfolio</v-tab>
                <v-tab class="tool-navigation-bar" href="#graph">Dashboard</v-tab>
                <v-tab class="tool-navigation-bar" href="#data">Blocking Chart</v-tab>
                <v-tab class="tool-navigation-bar" href="#forecasting">Forecasting</v-tab>
              </v-tabs>
            </v-row>
          </v-col>
        </v-row>
        <v-tabs-items
          class="ma-0 pa-0"
          v-model="performance_tab"
          style="height: 80%; max-height: 80%; width: 100%"
        >
          <v-tab-item
            style="height: 100%; max-height: 100%; width: 100%"
            value="performance"
          >
            <v-row width="100%" style="min-height: 10%" class="ma-0 pa-0">
              <PerformanceStatsTable
                :project_date_range="current_project_date_range"
                :data_levels="current_project_levels"
                :data_version="current_project_version"
                v-on:switch_tab="switch_tab"
                v-on:level_update="level_update"
                v-on:date_update="date_update"
                v-on:filter_update="update_data_filters"
                v-on:triggerAlert="triggerAlert"
                v-on:portfolio_quarter_delta_update="portfolio_quarter_delta_update"
                                      v-on:export="exportPortfolioPages"
                v-on:update_export_message="update_export_message"
                                      ref="performanceStateTable"
                                    />
            </v-row>
          </v-tab-item>
          <v-tab-item style="height: 100%; max-height: 100%; width: 100%" value="graph">
            <v-row width="100%" style="min-height: 10%" class="ma-0 pa-0">
              <PerformanceStatsGraph
                :project_date_range="current_project_date_range"
                                     :selected_channel="selected_channel"
                                     :data_levels="current_project_levels"
                                     :data_filters="current_project_filter_values"
                                     v-on:triggerAlert="triggerAlert"
                v-on:update_export_message="update_export_message"
                                     ref="performanceStateGraph"
                                     />
            </v-row>
          </v-tab-item>
          <v-tab-item style="height: 100%; max-height: 100%; width: 100%" value="data">
            <v-row width="100%" style="min-height: 10%" class="ma-0 pa-0">
              <PerformanceDataBreakdown
                :project_date_range="current_project_date_range"
                :data_levels="current_project_levels"
                :data_version="current_project_version"
                :data_filters="current_project_filter_values"
                v-on:switch_tab="switch_tab"
                v-on:level_update="level_update"
                v-on:date_update="date_update"
                                        v-on:triggerAlert="triggerAlert"
                                        />
            </v-row>
          </v-tab-item>

          <v-tab-item
            class="performance-forecasting-tab"
            value="forecasting"
          >
            <v-row
              v-if="current_project_id"
              width="100%"
              class="ma-0 pa-0 performance-forecasting-row"
            >
              <v-col cols="12" class="ma-0 pa-0 forecasting-panel">
                <v-row
                  v-if="current_planning_stage != 'my_plans'"
                  class="ma-0 pa-0 px-6 forecasting-tabs-row"
                  align="center"
                >
                  <v-chip
                    v-if="current_planning_stage != 'my_plans'"
                    label
                    color="black"
                    class="forecasting-subtab-chip"
                    :outlined="forecasting_tab !== 'saved'"
                    :text-color="forecasting_tab === 'saved' ? 'white' : 'black'"
                    @click="forecasting_tab = 'saved'"
                  >
                    My Plans
                  </v-chip>
                  <v-chip
                    v-if="current_planning_stage != 'my_plans'"
                    label
                    color="black"
                    class="forecasting-subtab-chip"
                    :outlined="forecasting_tab !== 'opt_setup_new'"
                    :text-color="forecasting_tab === 'opt_setup_new' ? 'white' : 'black'"
                    :disabled="current_planning_stage != 'optimization_setup' && current_planning_stage != 'prediction_stage'"
                    @click="forecasting_tab = 'opt_setup_new'"
                  >
                    Optimization Setup
                  </v-chip>
                  <v-chip
                    v-if="current_planning_stage != 'my_plans'"
                    label
                    color="black"
                    class="forecasting-subtab-chip"
                    :outlined="forecasting_tab !== 'prediction'"
                    :text-color="forecasting_tab === 'prediction' ? 'white' : 'black'"
                    :disabled="current_planning_stage != 'prediction_stage'"
                    @click="forecasting_tab = 'prediction'"
                  >
                    Optimization
                  </v-chip>
                  <v-spacer></v-spacer>
                  <v-col
                    class="ma-0 pa-0 px-1"
                    cols="auto"
                    v-if="forecasting_goto_prediction"
                  >
                    <v-select
                      v-model="optimization_model_version"
                      :items="optimization_model_options"
                      item-text="text"
                      item-value="value"
                      label="Model"
                      dense
                      outlined
                      hide-details
                      :disabled="forecasting_prediction_loading"
                      class="optimization-model-select"
                    ></v-select>
                  </v-col>
                  <v-col
                    class="ma-0 pa-0 px-1"
                    cols="auto"
                    v-if="forecasting_goto_prediction"
                  >
                    <v-btn outlined color="black" @click="flip_to_prediction" width="150">
                      <v-icon color="black" class="mr-2">mdi-calculator</v-icon>
                      <span class="planning_section_action_text">Optimize</span>
                    </v-btn>
                  </v-col>
                  <v-col
                    class="ma-0 pa-0 px-1"
                    cols="auto"
                    v-if="forecasting_tab == 'prediction'"
                  >
                    <v-btn
                      outlined
                      color="black"
                      width="150px"
                      @click="export_forecasting_prediction"
                      :disabled="forecasting_prediction_loading"
                    >
                      <v-icon class="mr-2" color="black">mdi-download</v-icon>
                      <span class="planning_section_action_text">Export</span>
                    </v-btn>
                  </v-col>
                  <v-col class="ma-0 pa-0 px-1" cols="auto" v-if="forecasting_can_edit">
                    <v-btn outlined color="black" width="150px" @click="edit_forecasting_plan" :disabled="forecasting_prediction_loading">
                      <v-icon class="mr-2" color="black">mdi-pencil</v-icon>
                      <span class="planning_section_action_text">Edit</span>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-tabs-items
                  class="ma-0 pa-0 forecasting-tab-items"
                  :class="{ 'forecasting-tab-items--full': current_planning_stage == 'my_plans' }"
                  v-model="forecasting_tab"
                >
                  <v-tab-item class="ma-0 pa-0 forecasting-tab-item" value="saved">
                    <v-row width="100%" class="ma-0 pa-0 forecasting-tab-content">
                      <ForecastingSaved
                        ref="performanceForecastingSaved"
                        :project_id="current_project_id"
                        :data_version="current_project_version"
                        :data_levels="current_project_levels"
                        :project_date_range="forecasting_project_date_range"
                        :project_filters="current_project_filters"
                        v-on:update_campaign_plan_id="handle_forecasting_plan_selected"
                        v-on:create_campaign_plan_id="handle_forecasting_plan_created"
                        v-on:date_update="update_forecasting_date_range"
                        v-on:triggerAlert="triggerAlert"
                      ></ForecastingSaved>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item
                    class="ma-0 pa-0 forecasting-tab-item"
                    value="opt_setup_new"
                  >
                    <v-row width="100%" class="ma-0 pa-0 forecasting-tab-content">
                      <ForecastingOptimizationSetup
                        :key="'optimization-setup-' + forecasting_opened_plan_component_key + '-' + campaign_plan_id"
                        :project_date_range="forecasting_project_date_range"
                        :data_levels="current_project_levels"
                        :data_version="current_project_version"
                        :project_plan_id="campaign_plan_id"
                        :project_filters="current_project_filters"
                        :model_version="optimization_model_version"
                        :optimizing="optimize_and_predict"
                        :optimization_data_updated="optimization_data_updated"
                        :response_curves_key="response_curves_key"
                        :active_forecasting_tab="forecasting_tab"
                        :current_planning_stage="current_planning_stage"
                        v-on:triggerAlert="triggerAlert"
                        v-on:optimizationSetupComplete="confirm_prediction"
                        v-on:optimizationSetupFailed="handle_optimization_setup_failed"
                        v-on:optimizationModelVersionResolved="set_optimization_model_version_from_setup"
                      ></ForecastingOptimizationSetup>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item
                    class="ma-0 pa-0 forecasting-tab-item"
                    value="prediction"
                  >
                    <v-row width="100%" class="ma-0 pa-0 forecasting-tab-content">
                      <ForecastingPrediction
                        v-if="current_planning_stage == 'prediction_stage'"
                        :key="'prediction-' + forecasting_opened_plan_component_key + '-' + campaign_plan_id"
                        :project_date_range="forecasting_project_date_range"
                        :data_levels="current_project_levels"
                        :data_version="current_project_version"
                        :project_plan_id="campaign_plan_id"
                        :saved="forecasting_pull_from_saved_opt"
                        :version_tag="forecasting_prediction_version_tag"
                        :model_version="optimization_model_version"
                        :data_filters="forecasting_plan_filters"
                        :show_blocking_chart="true"
                        ref="performance_planning_prediction_comp"
                        v-on:triggerAlert="triggerAlert"
                        v-on:optimization_finished="optimization_finished"
                        v-on:prediction_loading_update="update_forecasting_prediction_loading"
                      ></ForecastingPrediction>
                    </v-row>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PerformanceStatsTable from "./PerformanceStats/PerformanceStatsTable.vue";
import PerformanceStatsGraph from "./PerformanceStats/PerformanceStatsGraph.vue";
import PerformanceDataBreakdown from "./PerformanceStats/PerformanceDataBreakdown.vue";
import ForecastingSaved from "@/components/Forecasting/ForecastingSetup/ForecastingSaved.vue";
import ForecastingOptimizationSetup from "@/components/Forecasting/ForecastingSetup/ForecastingOptimizationSetup.vue";
import ForecastingPrediction from "@/components/Forecasting/ForecastingSetup/ForecastingPrediction.vue";

import PerformanceMainStatistic from "./PerformanceStats/PerformanceReportSections/PerformanceMainStatistic.vue";
import performance_table_data from "@/input_data/performance_table_data.json";

import logo from "@/assets/PerformanceLogo.png";

import api_caller from "@/javascript/data_info.js";
import api_caller_data from "@/javascript/data_retrieval.js";
import forecasting_api_caller from "@/javascript/forecasting.js";
import PPTXBuilderPortfolio from "@/javascript/export_builders/pptxBuilder_performance";
import retrieval_api_caller from "@/javascript/data_retrieval.js";

import { ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE, DELAY, EXPORT_DELAY_IN_MS } from "@/constants/constants.js";
const GENERIC_EXPORT_LOADING_MESSAGE =
  "Please Allow us a Few Minutes to Generate your Export";

export default {
  name: "PerformanceBasePage",
  components: {
    PerformanceStatsTable,
    PerformanceStatsGraph,
    PerformanceDataBreakdown,
    ForecastingSaved,
    ForecastingOptimizationSetup,
    ForecastingPrediction,
    PerformanceMainStatistic,
  },
  mounted() {
    this.reset_project_data();
    this.get_ticker();
  },
  beforeDestroy() {
    clearTimeout(this.alertTimeout);
  },
  watch: {
    $selectedTickerRange() {
      this.get_ticker();
  },
    $selected_levels() {
      this.get_ticker();
    },
    forecasting_tab: {
      immediate: true,
      handler: function (newTab, oldTab) {
        if (newTab == "opt_setup_new") {
          this.response_curves_key++;
        } else if (newTab == "saved") {
          this.current_planning_stage = "my_plans";
          if (oldTab) {
            this.refresh_forecasting_reports();
          }
        }
      },
      deep: true,
    },
  },
  data: () => ({
    main_logo: logo,
    performance_tab: "",
    forecasting_tab: "saved",
    dropdown_configs: performance_table_data["dropdown_options"],
    selected_channel: null,
    alertMsg: null,
    alertType: null,
    showAlert: false,
    alertTimeout: null,

    //All Project Variables:
    saved_projects: [],

    //Current Project Variables
    current_project_id: null,
    current_project_version: null,
    current_project_date_range: {
      start_date: null,
      end_date: null,
      min_start_date: null,
      max_end_date: null,
    },
    forecasting_project_date_range: {
      start_date: null,
      end_date: null,
      min_start_date: null,
      max_end_date: null,
    },
    current_project_levels: {
      data_levels: [],
      selected_levels: [],
      level_values: [],
    },
    current_project_filter_values: {},
    current_project_filters: {},

    total_attribution: null,
    total_roas: null, 
    total_spend: null,
    sliderElements: [],
    export_overlay: false,
    export_loading_message: null,
    current_planning_stage: "my_plans",
    planning_date_set: false,
    campaign_plan_id: null,
    plan_name: "",
    forecasting_opened_plan_component_key: 0,
    optimize_and_predict: false,
    optimization_data_updated: 0,
    optimization_model_version: "v1",
    optimization_model_options: [
      { text: "Model 1", value: "v1" },
      { text: "Model 2 (beta)", value: "v2" },
    ],
    response_curves_key: 0,
    forecasting_prediction_loading: false,
    forecasting_pull_from_saved_opt: false,
    forecasting_prediction_version_tag: null,
    forecasting_plan_filters: {},
  }),
  computed: {
    forecasting_goto_prediction() {
      return this.current_planning_stage == "optimization_setup";
    },
    forecasting_can_edit() {
      return this.current_planning_stage == "prediction_stage";
    },
  },
  methods: {
    get_default_performance_date_range: function (projectStartDate, projectEndDate) {
      let projectEndYear = Number(projectEndDate.split("-")[0]);
      let currentYear = new Date().getFullYear();
      let defaultYear = projectEndYear == currentYear ? currentYear : projectEndYear;
      let defaultStartDate = defaultYear + "-01-01";

      if (defaultStartDate < projectStartDate) {
        defaultStartDate = projectStartDate;
      }

      return {
        start_date: defaultStartDate,
        end_date: projectEndDate,
      };
    },
    reset_project_data: async function () {
      if (this.$project.get_val() == null) {
        return;
      }
      let token = await this.$auth.getTokenSilently();
      let project_info = await api_caller
        .get_project_info(token, this.$project.get_val())
        .then((resp) => {
          return resp["data"];
        })
        .catch(() => {
          return "False";
                          });
      let defaultDateRange = this.get_default_performance_date_range(
        project_info["start_date"],
        project_info["end_date"]
      );
      this.current_project_id = project_info["project_id"];
      this.current_project_version = project_info["version"];
      this.current_project_date_range = {
        start_date: defaultDateRange["start_date"],
        end_date: defaultDateRange["end_date"],
        min_start_date: project_info["start_date"],
        max_end_date: project_info["end_date"],
      };
      this.forecasting_project_date_range = {
        start_date: project_info["start_date"],
        end_date: project_info["end_date"],
        min_start_date: project_info["start_date"],
        max_end_date: project_info["end_date"],
      };
      this.current_project_levels = {
        data_levels: project_info["data_levels"],
        selected_levels: [project_info["data_levels"][0]],
        level_values: [],
      };
      this.current_project_filters = project_info["filter_base_values"] || {};
      this.forecasting_plan_filters = {};

      await this.get_project_highlights();
    },
    get_project_highlights: async function () {
      this.total_attribution = "-";
      this.total_roas = "-";
      this.total_spend = "-";
      if (this.$project.get_val() == null) {
        return;
      }
      let token = await this.$auth.getTokenSilently();
      let date_range = {
        start_date: this.current_project_date_range["start_date"],
        end_date: this.current_project_date_range["end_date"],
      };
      let highlight_data = await api_caller_data
        .get_highlights_data(
          token,
          this.$project.get_val(),
          date_range,
          this.current_project_filter_values
        )
        .then((resp) => {
          return resp["data"];
        })
        .catch(() => {
          return "False";
                          });
      this.total_attribution = highlight_data["attribution"];
      this.total_roas = highlight_data["roas"];
      this.total_spend = highlight_data["spend"];
    },
    switch_tab: function (tab, value) {
      this.performance_tab = tab;
      this.selected_channel = value;
    },
    level_update: function (levels) {
      this.current_project_levels = levels;
    },
    get_ticker: async function () {
      if (this.$selected_levels.length <= 2) {
        let token = await this.$auth.getTokenSilently();
        let ticker = await retrieval_api_caller
          .get_ticker_data(
            token,
            this.$tool_state,
            this.$selectedTickerRange,
            this.$selected_levels
          )
          .then((resp) => {
            return resp["data"];
          })
          .catch((e) => {
            console.error(e);
            return false;
          });
        if (!ticker) {
          return;
        }
        this.process_portfolio_quarter_delta(
          ticker["portfolio_data"],
          ticker["portfolio_data_prev_quarter"]
        );
      }
    },
    process_portfolio_quarter_delta(portfolio_data, portfolio_data_prev_quarter) {
      if (portfolio_data == null) {
        return;
      }
      let ads_unit_levels = Object.keys(portfolio_data["table_levels"]);
      function is_ads_unit(value) {
        for (let i = 0; i < ads_unit_levels.length; i++) {
          if (value[ads_unit_levels[i]] == null || value[ads_unit_levels[i]] == "") {
            return false;
          }
        }
        return true;
      }

      if (
        portfolio_data["table_content"] &&
        portfolio_data_prev_quarter["table_content"]
      ) {
        let table_metrics = [
          { value: "spend", text: "Spend" },
          { value: "roi", text: "ROI" },
          { value: "sales_attribution", text: "Sales Attribution" },
        ];

        let tmp_portfolio_data = { ...portfolio_data };
        tmp_portfolio_data["table_content"] = tmp_portfolio_data["table_content"].filter(
          is_ads_unit
        );

        let tmp_portfolio_data_prev_qrt = { ...portfolio_data_prev_quarter };
        tmp_portfolio_data_prev_qrt["table_content"] = tmp_portfolio_data_prev_qrt[
          "table_content"
        ].filter(is_ads_unit);

        let portfolio_data_delta = {
          table_headers: [],
          table_content: [],
          table_levels: ads_unit_levels,
          table_metrics: table_metrics,
        };
        portfolio_data_delta["table_headers"] = ads_unit_levels.concat(
          table_metrics.map((a) => a.value)
        );

        for (let i = 0; i < tmp_portfolio_data["table_content"].length; i++) {
          let row = {};
          ads_unit_levels.forEach((level) => {
            row[level] = tmp_portfolio_data["table_content"][i][level];
          });
          if (
            tmp_portfolio_data["table_content"][i] &&
            tmp_portfolio_data_prev_qrt["table_content"][i]
          ) {
            let old_data = tmp_portfolio_data_prev_qrt["table_content"][i];
            let new_data = tmp_portfolio_data["table_content"][i];
            row["spend"] = {
              value: new_data["spend"] - old_data["spend"],
              percentage:
                old_data["spend"] == 0
                  ? 0
                  : (new_data["spend"] - old_data["spend"]) / old_data["spend"],
            };
            row["roi"] = {
              value: new_data["roi"] - old_data["roi"],
              percentage:
                old_data["roi"] == 0
                  ? 0
                  : (new_data["roi"] - old_data["roi"]) / old_data["roi"],
            };
            row["sales_attribution"] = {
              value: new_data["sales_attribution"] - old_data["sales_attribution"],
              percentage:
                old_data["sales_attribution"] == 0
                  ? 0
                  : (new_data["sales_attribution"] - old_data["sales_attribution"]) /
                    old_data["sales_attribution"],
            };
            portfolio_data_delta["table_content"].push(row);
          }
        }
        this.portfolio_quarter_delta_update(portfolio_data_delta);
      }
    },
    portfolio_quarter_delta_update: function (portfolio_delta_data) {
      if (portfolio_delta_data["table_content"]) {
        let newSliderElements = [];

        portfolio_delta_data["table_content"].forEach((row) => {
          let ads_units_name = [];
          portfolio_delta_data["table_levels"].forEach((level) => {
            ads_units_name.push(row[level]);
          });
          let element_prex = ads_units_name.join("_");

          let element_text_overview = {
            name: element_prex,
            vol: 0,
            roi: 0,
            spend: 0,
          };

          portfolio_delta_data["table_metrics"].forEach((metric) => {
            element_text_overview[metric.text] = row[metric.value];
            // newSliderElements.push({
            //   'name': element_prex + "-" + metric.text,
            //   'value': row[metric.value]
            // })
          });
          newSliderElements.push(element_text_overview);
        });
        this.sliderElements = newSliderElements;
      }
    },
    triggerAlert: function (type, message, source) {
      console.warn("[PerformanceBasePage Alert]", {
        type: type,
        message: message,
        source: source,
        performance_tab: this.performance_tab,
        forecasting_tab: this.forecasting_tab,
        current_planning_stage: this.current_planning_stage,
        campaign_plan_id: this.campaign_plan_id,
      });
      this.alertType = type ? type : "info";
      this.alertMsg = message;
      this.showAlert = true;
      clearTimeout(this.alertTimeout);
      this.alertTimeout = setTimeout(() => {
        this.showAlert = false;
        this.alertTimeout = null;
      }, 5000);
    },
    date_update: function (date) {
      this.current_project_date_range["start_date"] = date["start_date"];
      this.current_project_date_range["end_date"] = date["end_date"];
      this.get_project_highlights();
    },
    update_data_filters: function (data_filters) {
      this.current_project_filter_values = data_filters;
      this.get_project_highlights();
    },

    flip_to_prediction: function () {
      this.forecasting_pull_from_saved_opt = false;
      this.forecasting_prediction_version_tag = null;
      this.forecasting_prediction_loading = true;
      this.optimize_and_predict = true;
    },

    confirm_prediction: function (version_tag) {
      this.optimize_and_predict = false;
      this.forecasting_pull_from_saved_opt = false;
      this.forecasting_prediction_version_tag = version_tag || null;
      this.current_planning_stage = "prediction_stage";
      this.forecasting_tab = "prediction";
      this.forecasting_prediction_loading = true;
    },

    optimization_finished: function () {
      this.optimization_data_updated += 1;
      this.forecasting_prediction_loading = false;
    },

    update_forecasting_prediction_loading: function (is_loading) {
      this.forecasting_prediction_loading = is_loading;
    },

    set_optimization_model_version_from_setup: function (modelVersion) {
      const isValidModelVersion = this.optimization_model_options.some((option) => {
        return option.value === modelVersion;
      });
      if (isValidModelVersion) {
        this.optimization_model_version = modelVersion;
      }
    },

    handle_optimization_setup_failed: function () {
      this.forecasting_prediction_loading = false;
      this.optimize_and_predict = false;
    },

    refresh_forecasting_reports: function () {
      this.$nextTick(() => {
        if (
          this.$refs.performanceForecastingSaved &&
          this.$refs.performanceForecastingSaved.get_forecasting_reports
        ) {
          this.$refs.performanceForecastingSaved.get_forecasting_reports();
        }
      });
    },

    update_forecasting_date_range: function (date) {
      this.planning_date_set = true;
      this.forecasting_project_date_range = {
        ...this.forecasting_project_date_range,
        start_date: date["start_date"],
        end_date: date["end_date"],
      };
    },

    update_forecasting_report_stage: async function (stage) {
      if (!this.campaign_plan_id || !this.current_project_id) {
        return false;
      }

      let token = await this.$auth.getTokenSilently();
      return forecasting_api_caller
        .update_campaign_plan(token, {
          project_id: this.current_project_id,
          report_id: this.campaign_plan_id,
          stage,
        })
        .then((resp) => {
          return Boolean(resp && resp["success"]);
        })
        .catch(() => {
          return false;
        });
    },

    edit_forecasting_plan: async function () {
      if (this.forecasting_prediction_loading) {
        return;
      }
      const stageUpdated = await this.update_forecasting_report_stage("OPTIMIZATION");
      if (!stageUpdated) {
        this.triggerAlert(ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
        return;
      }
      this.forecasting_pull_from_saved_opt = false;
      this.forecasting_prediction_version_tag = null;
      this.current_planning_stage = "optimization_setup";
      this.forecasting_tab = "opt_setup_new";
    },

    get_forecasting_plan_filters: function (metadata) {
      if (
        metadata &&
        metadata["data_filters"] &&
        typeof metadata["data_filters"] === "object" &&
        !Array.isArray(metadata["data_filters"])
      ) {
        return metadata["data_filters"];
      }

      return {};
    },

    handle_forecasting_plan_created: function (campaign_plan_id, name, metadata) {
      if (this.$refs.performanceForecastingSaved) {
        this.$refs.performanceForecastingSaved.create_plan_dialog = false;
      }
      this.campaign_plan_id = campaign_plan_id;
      this.forecasting_plan_filters = this.get_forecasting_plan_filters(metadata);
      this.planning_date_set = true;
      this.current_planning_stage = "optimization_setup";
      this.forecasting_tab = "opt_setup_new";
      this.forecasting_prediction_loading = false;
      this.forecasting_pull_from_saved_opt = false;
      this.forecasting_prediction_version_tag = null;
      this.plan_name = name;
    },

    handle_forecasting_plan_selected: function (campaign_plan_id, name, stage, metadata) {
      this.forecasting_opened_plan_component_key += 1;
      this.campaign_plan_id = campaign_plan_id;
      this.forecasting_plan_filters = this.get_forecasting_plan_filters(metadata);
      this.planning_date_set = true;
      this.set_opened_forecasting_plan_stage(stage);
      this.plan_name = name;
    },

    set_opened_forecasting_plan_stage: function (stage) {
      const normalizedStage = stage ? stage.toString().toUpperCase() : null;

      if (normalizedStage === "PREDICTION") {
        this.forecasting_pull_from_saved_opt = true;
        this.forecasting_prediction_version_tag = null;
        this.current_planning_stage = "prediction_stage";
        this.forecasting_tab = "prediction";
        this.forecasting_prediction_loading = true;
        return;
      }

      this.forecasting_pull_from_saved_opt = false;
      this.forecasting_prediction_version_tag = null;
      this.current_planning_stage = "optimization_setup";
      this.forecasting_tab = "opt_setup_new";
      this.forecasting_prediction_loading = false;
    },

    export_forecasting_prediction: async function () {
      if (this.forecasting_prediction_loading || !this.$refs.performance_planning_prediction_comp) {
        return;
      }
      this.export_loading_message = GENERIC_EXPORT_LOADING_MESSAGE;
      this.export_overlay = true;
      await this.$refs.performance_planning_prediction_comp.exportPredictionPages(
        this.plan_name
      );
      this.export_overlay = false;
    },

    update_export_message: function (message) {
      this.export_loading_message = message;
    },

    exportPortfolioPages: async function () {

      this.export_loading_message = GENERIC_EXPORT_LOADING_MESSAGE;

      this.export_overlay = true;

      await DELAY(EXPORT_DELAY_IN_MS);

      const pptxBuilder = new PPTXBuilderPortfolio();

      const current_tab = this.performance_tab;

      this.performance_tab = "performance";
      this.export_loading_message = "Exporting Portfolio Page";

      //get portfolio page export elements
      const portfolioComp = this.$refs["performanceStateTable"];

      const portfolioElements = await portfolioComp.build_export_pages();

      // build portfolio tables
      portfolioElements["portfolio_tables"].forEach((table) => {
        pptxBuilder.add_portfolio_element(table, "table");
      });

      // build portfolio charts
      portfolioElements["portfolio_charts"].forEach((chart) => {
        pptxBuilder.add_portfolio_element(chart, "chart");
      });

      //get dashboard page export elementsort elements
      this.performance_tab = "graph";

      await DELAY(EXPORT_DELAY_IN_MS);
      const dashboardComp = this.$refs["performanceStateGraph"];
      const dashboardElements = await dashboardComp.build_export_pages();

      dashboardElements.forEach((element) => {
        pptxBuilder.add_dashboard_page(element);
      });

      pptxBuilder.build();
      pptxBuilder.save();

      this.performance_tab = current_tab;
      await DELAY(EXPORT_DELAY_IN_MS);
      this.export_overlay = false;
    },
  },
};
</script>

<style scoped>
  .page-title {
    font-family: "Poppins" !important;
    font-weight: 800;
    font-size: 2em;
  }

  .drop-down-filter {
    margin-top: -20px;
    padding-top: 0px;
  }

  .tool-navigation-bar {
    font-family: "Poppins" !important;
    font-weight: 400 !important;
    font-size: 0.9em !important;
  }

  .forecasting-panel,
  .performance-forecasting-row,
  .forecasting-tab-content {
    height: 100%;
  }

  .performance-base-container {
    max-height: calc(100vh - 93px);
    width: 100%;
  }

  .slider-summary-row {
    width: 100%;
  }

  .performance-forecasting-tab {
    height: calc(100vh - 260px);
    max-height: calc(100vh - 260px);
    width: 100%;
  }

  .forecasting-tabs-row {
    min-height: 48px;
  }

  .forecasting-subtab-chip {
    border-radius: 4px !important;
    font-family: "Poppins" !important;
    font-size: 0.9em !important;
    font-weight: 600 !important;
    height: 32px !important;
    justify-content: center;
    margin-right: 3px;
    min-width: 126px;
  }

  .forecasting-tab-items {
    height: calc(100% - 48px);
    max-height: calc(100% - 48px);
    width: 100%;
  }

  .forecasting-tab-items--full {
    height: 100%;
    max-height: 100%;
  }

  .forecasting-tab-item {
    height: 100%;
    max-height: 100%;
    width: 100%;
  }

  .planning_section_action_text,
  .optimization_calculator_action {
    font-family: "Poppins" !important;
    font-weight: 400 !important;
    font-size: 0.9em !important;
    color: black;
  }

  .optimization-model-select {
    width: 190px;
  }

  .optimization-model-select ::v-deep .v-select__selection {
    max-width: none;
  }

  .optimization-model-select ::v-deep .v-select__selection--comma {
    overflow: visible;
    text-overflow: clip;
    white-space: nowrap;
  }

  .optimization_create_title {
    font-family: "Poppins" !important;
    font-weight: 600;
  }

  .marquee_slider {
  background: #1b1b1b !important;
  }

  .sliderElement {
    font-family: "Poppins" !important;
    font-size: 1em;
    font-weight: 400;
    color: #ffffff;
    height: 40px;
    line-height: 40px;
    .sliderElementValueGreen {
    color: green;
    }
    .sliderElementValueRed {
    color: red;
    }
    .sliderElementIcon {
      padding-bottom: 4px;
      font-size: 1.25em;
    }
  }

  /deep/.v-window__container {
    height: 100% !important;
  }
.statistic_value_text {
    font-family: "Amiko";
    font-size: 30pt;
  }
.statistic_title {
    font-family: "Amiko";
    font-size: 10pt;
  }

  .overlay_card {
    background: white;
    position: fixed;
    height: 100vh;
    width: 100%;
    left: 0;
    right: 0;
    top: 0px;
  }

  .marquee_slider {
    background: #1b1b1b !important;
  }

  .sliderElement {
    font-family: "Poppins" !important;
    font-size: 1em;
    font-weight: 400;
    color: #ffffff;
    height: 40px;
    line-height: 40px;
    .sliderElementValueGreen {
      color: green;
    }
    .sliderElementValueRed {
      color: red;
    }
    .sliderElementIcon {
      padding-bottom: 4px;
      font-size: 1.25em;
    }
  }
  .alert_overlay {
    position: absolute;
    width: 100%;
    z-index: 99;
  }
</style>
